import { useEffect, useState } from 'react';
import {
  AUXILIARY_ORG_TYPES,
  FinancialAccountNode,
  OrgNode,
} from '../../../services/orgs/interfaces';
import OrgsService from '../../../services/orgs';
import { extractErrorMessage } from '../../../util/errorMessage';

export default function useFinancialAccountRoots({
  org,
  orgDataIsFinished,
}: {
  org?: OrgNode;
  orgDataIsFinished: boolean;
}): {
  financialAccountRoots?: FinancialAccountNode[];
  errorMessage?: string;
  isFinished: boolean;
} {
  const [financialAccountRoots, setFinancialAccountRoots] =
    useState<FinancialAccountNode[]>();
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const gatherData = async (): Promise<void> => {
      if (orgDataIsFinished && org === undefined) {
        setIsFinished(true);
      } else if (
        financialAccountRoots === undefined &&
        org?.id !== undefined &&
        org?.id !== null &&
        orgDataIsFinished
      ) {
        try {
          let retrievedFinancialAccountRoots =
            await OrgsService.financialAccountRoot(org.id);
          // only return fa roots up until the first aux org type
          // ex: if a campaign pays out to a Booster don't include nodes after it like School
          const orgTerminationIndex = retrievedFinancialAccountRoots.findIndex(
            (rfar) =>
              rfar.orgType && AUXILIARY_ORG_TYPES.includes(rfar.orgType),
          );
          retrievedFinancialAccountRoots = retrievedFinancialAccountRoots.slice(
            0,
            // if an aux org is found slice the array to include that org,
            // otherwise return the entire array
            orgTerminationIndex !== -1 ? orgTerminationIndex + 1 : undefined,
          );
          setFinancialAccountRoots(retrievedFinancialAccountRoots);
        } catch (e) {
          setErrorMessage(extractErrorMessage(e));
        } finally {
          setIsFinished(true);
        }
      }
    };
    gatherData();
  }, [financialAccountRoots, org, org?.id, orgDataIsFinished]);

  return {
    financialAccountRoots,
    errorMessage,
    isFinished,
  };
}
